export {ReactComponent as default} from '../../assets/icons/graphql.svg';
